module.exports = __webpack_public_path__ + "static/media/icon-gym.554a5389.svg";